import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { SELECTORS, ATTRIBUTES, getProductCard } from '@/scripts/core/global'

export class CardSwatch extends UcoastEl {
    static htmlSelector = 'card-swatch'
    cardWrapper: HTMLElement
    swatches: NodeListOf<HTMLButtonElement | HTMLAnchorElement>

    constructor() {
        super()

        this.cardWrapper = q.rc(this, '.product-card-wrapper')
        this.swatches = q.rl('.card-swatch-button', this)

        this.swatches.forEach(swatch => {
            swatch.addEventListener('click', this.updateCard.bind(this))
        })
    }

    getSpinner(target: HTMLButtonElement | HTMLAnchorElement) {
        return q.rs(SELECTORS.loadingOverlaySpinner, target)
    }

    async updateCard(e: Event) {
        const target = e.currentTarget as HTMLButtonElement | HTMLAnchorElement
        if(!target) return
        const url = target.dataset.url
        if(!url || target.classList.contains('active')) return
        e.preventDefault()
        target.setAttribute('aria-disabled', 'true')
        target.setAttribute(ATTRIBUTES.loading, '')
        this.getSpinner(target).classList.remove('hidden')
        const useEmbroideryCardImage =
            this.dataset.ucUseEmbroideryCardImage === 'true'
        const wrapper = await getProductCard(url, useEmbroideryCardImage)
        this.cardWrapper.innerHTML = wrapper.outerHTML
    }
}
